import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import MongoRequestHandler from "../../helpers/MongoRequestHandler";
import { motion } from "framer-motion";
import EmotionModelHandler from '../../helpers/EmotionModelHandler'; 
import "./Dev.css";


export default function Dev() {
    const TEST_IMAGE_ID = "status";
    const fileInputRef = useRef(null);
    const [imageData, setImageData] = useState(null);
    const [imageName, setImageName] = useState('');
    const [feedbackMessage, setFeedbackMessage] = useState("");
    const [availableFor, setAvailableFor] = useState("study_one");

    const [nodeServerStatus, setNodeServerStatus] = useState("");
    const [emoAiServiceStatus, setEmoAiServiceStatus] = useState("");
    const [azureServiceStatus, setAzureServiceStatus] = useState("");
    const [databaseStatus, setDatabaseStatus] = useState("");
    
    const testAzureServiceStatus = async () => {
        try {
            const azureStatus = await new EmotionModelHandler().testServerStatus();
            console.log("Azure service status:", azureStatus);
            setAzureServiceStatus(azureStatus);

            try {
                // this will definitely throw an error because no file is uploaded
                const formData = new FormData();
                await new EmotionModelHandler(azureStatus).processImage(formData);
            } catch (error) {
                if (error.message && error.message.includes("status: 400")) {
                    console.log("Successfully received expected 400 status from processImage (likely 'No file uploaded'). Service is responsive.");
                    setEmoAiServiceStatus(true); 
               } else {
                    console.error("Failed during initial /test check:", error);
                    setEmoAiServiceStatus(false);
               }
            }

        } catch (error) {
            console.error("Failed to check Azure status:", error);
            setAzureServiceStatus(false);
        }
    };

    const testNodeServerStatus = async () => {
        try {
            const status = await new MongoRequestHandler().testServerStatus();
            console.log("Node server status:", status);
            setNodeServerStatus(status);
        } catch (error) {
            console.error('Node server offline:', error);
            setNodeServerStatus(false);
        }
    };
    
    const testDatabaseStatus = async () => {
        try {
            const response = await new MongoRequestHandler().fetchSampleImageById(TEST_IMAGE_ID);
            console.log("Node server status:", response.imageId == TEST_IMAGE_ID);
            setDatabaseStatus(response.imageId == TEST_IMAGE_ID);
        } catch (error) {
            console.error('Database offline:', error);
            setDatabaseStatus(false);
        }
    };

    useEffect(() => {
        testNodeServerStatus();
        testAzureServiceStatus();
        testDatabaseStatus();
    }, []);

    const selectImageOnClick = () => {
        fileInputRef.current.click();
    };

    const handleImageNameChange = (e) => {
        setImageName(e.target.value);
    };

    const handleImageChange = (event) => {
        setFeedbackMessage("");

        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImageData(e.target.result);
            };
            reader.readAsDataURL(file);

            if (!imageName) {
                setImageName(file.name.split('.')[0]);
            }
        }
    };

    const uploadImage = async () => {
        if (imageData) {
            const mongoRequestHandler = new MongoRequestHandler();
            const imagePayload = {
                imageUrl: `${imageData}`,
                imageId: imageName,
                availableFor: availableFor
            };

            try {
                const result = await mongoRequestHandler.handleInsertSampleImage(imagePayload);
                if (result.sample) {
                    setFeedbackMessage("Image uploaded successfully!");
                } else {
                    setFeedbackMessage("Failed to upload image.");
                }
            } catch (error) {
                setFeedbackMessage("Failed to upload image. Error: ", error);
            }
        } else {
            setFeedbackMessage("Please select an image first.");
        }
    };

    return (
        <div className="content">
            <div className="tabcontent">
                <Container className="study-item">
                    <h1 style={{ fontWeight: 'bold' }}>Dev Portal</h1>
                    
                    <Row className="my-4">
                        <Form.Group controlId="formFile" className="mb-3">
                            <h5>Upload a sample image</h5>
                            <Form.Control
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                        </Form.Group>
                        
                        <Row>
                            <Col>
                                <Form.Label>Image Preview</Form.Label>
                                <div
                                    className="preview-image-container "
                                    onClick={selectImageOnClick}
                                >
                                    {imageData ? (
                                        <img
                                            src={imageData}
                                            alt="Selected Preview"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    ) : (
                                        <p>Click here or the select button below to select an image</p>
                                    )}
                                </div>

                            </Col>

                            <Col>
                                <Form.Group className="my-3">
                                    <Form.Label>Image Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={imageName}
                                        placeholder="Enter image name"
                                        onChange={handleImageNameChange}
                                    />
                                </Form.Group>
                                <Form.Group className="my-3">
                                    <Form.Label>Available For</Form.Label>
                                    <Form.Select 
                                        value={availableFor} 
                                        onChange={(e) => setAvailableFor(e.target.value)}
                                    >
                                        <option value="study_one">Study One</option>
                                        <option value="study_two">Study Two</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>


                        <Row className="mt-3">
                            <motion.button
                                type="button"
                                className="col button select-photo-button me-3"
                                title="Select Image"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.8 }}
                                id="selectImageButton"
                                onClick={selectImageOnClick}
                            >
                                <i className='bx bx-image-add control-button-icon' />
                                <span className="text control-button-text">Select</span>
                            </motion.button>
                            
                            <motion.button
                                type="button"
                                className="col button process-image-button"
                                title="Upload Image"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.8 }}
                                id="uploadImageButton"
                                onClick={uploadImage}
                            >
                                <i className='bx bx-upload control-button-icon' />
                                <span className="text control-button-text">Upload</span>
                            </motion.button>
                        </Row>
                    </Row>

                    {feedbackMessage && <p className="mt-2">{feedbackMessage}</p>}



                    <div className="status-banner">
                        <Container>
                            <Row className="status-row">
                                <Col className="status-container">
                                    <h5 className="status-text">
                                        Node Server Status:
                                        {nodeServerStatus.toString() ? (
                                            <span className={`status-indicator ${nodeServerStatus}`}>
                                                <i className={nodeServerStatus ? "bx bx-station" : "bx bx-no-signal"} />
                                                <span>{nodeServerStatus}</span>
                                            </span>
                                        ) : (
                                            <div className="loader loading"/>
                                        )}
                                    </h5>
                                </Col>

                                <Col className="status-container">
                                    <h5 className="status-text">
                                        Emo AI Service Status:
                                        {emoAiServiceStatus.toString() ? (
                                            <span className={`status-indicator ${emoAiServiceStatus}`}>
                                                <i className={emoAiServiceStatus ? "bx bx-station" : "bx bx-no-signal"} />
                                                <span>{emoAiServiceStatus}</span>
                                            </span>
                                        ) : (
                                            <div className="loader loading"/>
                                        )}
                                    </h5>
                                </Col>

                                <Col className="status-container">
                                    <h5 className="status-text">
                                        Database Status:
                                        {databaseStatus.toString() ? (
                                            <span className={`status-indicator ${databaseStatus}`}>
                                                <i className={databaseStatus ? "bx bx-station" : "bx bx-no-signal"} />
                                                <span>{databaseStatus}</span>
                                            </span>
                                        ) : (
                                            <div className="loader loading"/>
                                        )}
                                    </h5>
                                </Col>
                                <Col className="status-container">
                                    <h5 className="status-text">
                                        Azure Service Status:
                                        {azureServiceStatus.toString() ? (
                                            <span className={`status-indicator ${azureServiceStatus}`}>
                                                <i className={azureServiceStatus ? "bx bx-station" : "bx bx-no-signal"} />
                                                <span>{azureServiceStatus}</span>
                                            </span>
                                        ) : (
                                            <div className="loader loading"/>
                                        )}
                                    </h5>
                                </Col>
                            </Row>
                        </Container>
                    </div>


                </Container>
            </div>
        </div>
    );
}
